import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  generateTemplateNameErrorMessage,
  generateTemplateVisibilityErrorMessage,
} from "../../../MessageComponents/Constants/MessageConstants";
import { IMessageTemplateState } from "../../Typings/MessageState";
import { RootState } from "../Store";

const defaultMessageTemplateState: IMessageTemplateState = {
  name: "",
  visibility: "",
  showSaveTemplateOptions: false,
  showTemplateDialog: false,
};

export const MessageDialogTemplateSlice = createSlice({
  name: "messageDialogTemplate",
  initialState: defaultMessageTemplateState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      const nameErrorMessage = generateTemplateNameErrorMessage(action.payload);
      state.name = action.payload;
      state.nameErrorMessage = nameErrorMessage;
    },
    setVisibility: (state, action: PayloadAction<string>) => {
      const visibilityErrorMessage = generateTemplateVisibilityErrorMessage(action.payload);
      state.visibility = action.payload;
      state.visibilityErrorMessage = visibilityErrorMessage;
    },
    setShowSaveTemplateOptions: (state, action: PayloadAction<boolean>) => {
      state.showSaveTemplateOptions = action.payload;
    },
    setShowTemplateDialog: (state, action: PayloadAction<boolean>) => {
      state.showTemplateDialog = action.payload;
    },
    toggleShowTemplateDialog: (state) => {
      state.showTemplateDialog = !state.showTemplateDialog;
    },
    toggleShowSaveTemplateOptions: (state) => {
      state.showSaveTemplateOptions = !state.showSaveTemplateOptions;
    },
    clearTemplateInput: (state) => {
      state.name = "";
      state.visibility = "";
      state.nameErrorMessage = undefined;
      state.visibilityErrorMessage = undefined;
    },
  },
});
// Action creators are generated for each case reducer function
export const {
  setName,
  setVisibility,
  setShowSaveTemplateOptions,
  setShowTemplateDialog,
  toggleShowSaveTemplateOptions,
  toggleShowTemplateDialog,
  clearTemplateInput,
} = MessageDialogTemplateSlice.actions;

export const selectMessageTemplateState = (state: RootState) => state.messageDialogTemplate;

export default MessageDialogTemplateSlice.reducer;
